import React, { createContext, useMemo } from 'react';
import { SinglePriceConfigType } from '../../types/SinglePriceContent';

interface PriceConfigProviderProps {
  children: React.ReactNode;
  priceConfig: SinglePriceConfigType;
}

export const priceContext = createContext<SinglePriceConfigType>({} as SinglePriceConfigType);
const { Provider } = priceContext;

const PriceConfigProvider: React.FC<PriceConfigProviderProps> = ({ children, priceConfig }) => {
  const dataBag = useMemo<SinglePriceConfigType>(() => priceConfig, [priceConfig]);

  return <Provider value={dataBag}>{children}</Provider>;
};

export default PriceConfigProvider;
